import * as React from 'react'
import {useAuth0} from '@auth0/auth0-react'
import {client} from './api-client'
import {useSelector} from 'react-redux'
import {selectUserRoles} from '../app-store/selector'

function useAuthClient() {
  const {getAccessTokenSilently} = useAuth0()
  const {actualRole, switchedRole} = useSelector(selectUserRoles)
  // console.log('actualRole - authClient.js - useSelector', actualRole)
  // console.log('switchedRole - authClient.js - useSelector', switchedRole)

  return React.useCallback(
    async (endpoint, config) => {
      let token
      try {
        token = await getAccessTokenSilently()
      } catch (error) {
        const isLoginRequired =
          error?.error === 'login_required' ||
          error?.message === 'Login required'
        if (isLoginRequired) {
          console.log('Login required: OAuth session expired')
          return
        }
        throw error
      }
      const roleHeaders = {
        'x-actual-role': actualRole?.[0] || '',
        'x-switched-role': switchedRole?.[0] || '',
      }
      return client(endpoint, {
        ...config,
        token,
        headers: {
          ...(config?.headers || {}),
          ...roleHeaders,
        },
      })
    },
    // getAccessTokenSilently won't never change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  )
}

export {useAuthClient}
